export default __webpack_public_path__ + "static/media/profile.0a7363e2.jpeg";